module.exports = __webpack_public_path__ + "static/media/shop.8ba90d5f.png";